// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.login-container {
    position: relative;
    display: flex;
    width: 80vw;
    max-width: 900px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
}

.login-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.login-form {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.password-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
}

.login-form h2 {
    margin-bottom: 10px;
    font-size: 1.5em;
}

.login-form p {
    margin-bottom: 20px;
    color: #666;
}

.login-button-modal {
    background-color: #AB2F40;
    color: white;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    font-size: 1em;
    cursor: pointer;
    margin-right: 0rem !important;
}

.or-separator {
    margin: 20px 0;
    color: #666;
    font-size: 0.9em;
}

form input[type="email"], form input[type="password"] {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

form input[type="email"]::placeholder, form input[type="password"]::placeholder {
    color: #999;
}

.login-disabled-text {
    color: #666;
    font-size: 0.9em;
    margin-bottom: 10px;
}

.login-disabled-text a {
    color: #4793ef;
    text-decoration: underline;
    display: inline-block;
    margin: 5px;
}

.social-buttons-container {
    display: flex;
    flex-direction: column;
    width: 240px;
    gap: 0.5rem;
}

.google-button, .facebook-button {
    width: 100% !important; /* Importante para asegurar que ocupen el 100% del contenedor */
    padding: 10px;
    
    border: none;
    border-radius: 4px;
    font-size: 1em;
    cursor: pointer;
    border-radius: 0.5rem;
}

.disabled {
    pointer-events: none;
    opacity: 0.6;
}

/*.login-disabled-text {*/
/*    color: red;*/
/*    font-size: 0.8em;*/
/*    margin-bottom: 1rem;*/
/*}*/

.error-message-login {
    color: red !important;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  

@media (max-width: 1350px) {
    .login-image {
        display: none;
    }

    .login-container {
        width: 80vh;
        max-width: 500px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB,EAAE,+DAA+D;IACvF,aAAa;;IAEb,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA,yBAAyB;AACzB,kBAAkB;AAClB,wBAAwB;AACxB,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;;AAGF;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".login-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.login-container {\n    position: relative;\n    display: flex;\n    width: 80vw;\n    max-width: 900px;\n    background: #fff;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.login-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 24px;\n    cursor: pointer;\n}\n\n.login-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.login-form {\n    padding: 20px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.password-form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.login-form h2 {\n    margin-bottom: 10px;\n    font-size: 1.5em;\n}\n\n.login-form p {\n    margin-bottom: 20px;\n    color: #666;\n}\n\n.login-button-modal {\n    background-color: #AB2F40;\n    color: white;\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    border: none;\n    border-radius: 4px;\n    font-size: 1em;\n    cursor: pointer;\n    margin-right: 0rem !important;\n}\n\n.or-separator {\n    margin: 20px 0;\n    color: #666;\n    font-size: 0.9em;\n}\n\nform input[type=\"email\"], form input[type=\"password\"] {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n\nform input[type=\"email\"]::placeholder, form input[type=\"password\"]::placeholder {\n    color: #999;\n}\n\n.login-disabled-text {\n    color: #666;\n    font-size: 0.9em;\n    margin-bottom: 10px;\n}\n\n.login-disabled-text a {\n    color: #4793ef;\n    text-decoration: underline;\n    display: inline-block;\n    margin: 5px;\n}\n\n.social-buttons-container {\n    display: flex;\n    flex-direction: column;\n    width: 240px;\n    gap: 0.5rem;\n}\n\n.google-button, .facebook-button {\n    width: 100% !important; /* Importante para asegurar que ocupen el 100% del contenedor */\n    padding: 10px;\n    \n    border: none;\n    border-radius: 4px;\n    font-size: 1em;\n    cursor: pointer;\n    border-radius: 0.5rem;\n}\n\n.disabled {\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n/*.login-disabled-text {*/\n/*    color: red;*/\n/*    font-size: 0.8em;*/\n/*    margin-bottom: 1rem;*/\n/*}*/\n\n.error-message-login {\n    color: red !important;\n    font-size: 14px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  \n\n@media (max-width: 1350px) {\n    .login-image {\n        display: none;\n    }\n\n    .login-container {\n        width: 80vh;\n        max-width: 500px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
